export default __webpack_public_path__ + "static/media/hr-result.34d1f1d6.png";